import {
  ChartNoAxesCombined,
  Eye,
  History,
  Info,
  ShieldCheck,
  type LucideIcon,
} from 'lucide-react';

export type DocumentDetailTabId =
  | 'preview'
  | 'metadata'
  | 'analysis'
  | 'versions'
  | 'permissions';

export interface DocumentDetailTab {
  id: DocumentDetailTabId;
  labelKey: string;
  icon: LucideIcon;
}

export const DOCUMENT_DETAIL_TABS: DocumentDetailTab[] = [
  { id: 'preview', labelKey: 'documents.preview', icon: Eye },
  { id: 'metadata', labelKey: 'documents.metadata', icon: Info },
  { id: 'analysis', labelKey: 'documents.analysisHistory', icon: ChartNoAxesCombined },
  { id: 'versions', labelKey: 'documents.versionHistory', icon: History },
  { id: 'permissions', labelKey: 'documents.permissions', icon: ShieldCheck },
];

export const MAX_VISIBLE_TAGS = 10;

/** Sequence analysis is rejected by the backend past this many images. */
export const MAX_SEQUENCE_IMAGES = 10;

/**
 * A document with many extracted figures (PDFs with diagrams) used to fire N
 * parallel /documents/{id}/images/{id} requests via Promise.all, easily
 * exhausting the per-user rate-limit budget (100 req/60s) and producing a 429
 * cascade. Batching means a 200-image document loads in waves of 4 rather than
 * one burst.
 */
export const IMAGE_BLOB_CONCURRENCY = 4;

export const COMPARISON_TYPES = ['changes', 'evolution', 'differences'] as const;

export type ComparisonType = (typeof COMPARISON_TYPES)[number];

export const DEFAULT_COMPARISON_TYPE: ComparisonType = 'evolution';

/** Rendered inline as an <img>; anything else falls back to the unavailable panel. */
export const PREVIEWABLE_IMAGE_TYPES = ['png', 'jpg', 'jpeg', 'gif'];

/** MIME subtype produced by `mimeType.split('/')` for an XLSX document. */
export const PREVIEWABLE_SPREADSHEET_TYPES = [
  'xlsx',
  'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

/** Raster resolution requested when re-extracting a page as a blueprint. */
export const BLUEPRINT_EXTRACT_DPI = 150;
